import { FilterAutocomplete } from '../baseInputTypes/FilterAutocomplete'

type Props = {}
export const TargetRegions = (props: Props) => (
  <FilterAutocomplete
    label="Target Regions"
    fieldName={'targetRegions'}
    fieldPath={'productInformation.targetRegions'}
  />
)
